<template lang="pug">
v-hips-png-layer(
  v-if="frameStore.baseUrl !== undefined"
  :fade="false",
  :baseUrl="frameStore.baseUrl",
  :animationLod="Store.config.hipsLayer.animationLod",
  :lodBias="Store.config.hipsLayer.lodBias")
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FrameStore } from "@/modules/base";
import { HipsModule } from "@/modules/HipsModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof HipsModule>
}
</script>
